import React from 'react';
import PropTypes from 'prop-types';
import Iframe from '../shared/Iframe';

/**
 * Sketchfab component
 *
 * @param props
 * @returns {XML}
 * @constructor
 */

const Sketchfab = props => {
  const autoplay = props.params.ludus.autoplay ? 1 : 0;
  const camera = props.params.ludus.camera ? 1 : 0;
  const autospin = props.params.ludus.autospin ? 1 : 0;
  const transparent = props.params.ludus.transparent ? 1 : 0;

  return (
    <Iframe
      title="Sketchfab"
      src={`${props.params.ludus.url}?autospin=${autospin}&autostart=${autoplay}&camera=${camera}&transparent=${transparent}`}
      transitionStatus={props.transitionStatus}
      style={props.style}
      params={props.params}
      applyScaleFix={props.applyScaleFix}
      globalScale={props.globalScale}
      windowHasFocus={props.windowHasFocus}
      groupOpacity={props.groupOpacity}
      groupAngle={props.groupAngle}
      groupScaleX={props.groupScaleX}
      groupScaleY={props.groupScaleY}
      showLoader={false}
      matrixGroup={props.matrixGroup}
      isScalable={false}
    />
  );
};

Sketchfab.propTypes = {
  style: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  ).isRequired,
  params: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.bool,
      PropTypes.func,
      PropTypes.number,
      PropTypes.object,
      PropTypes.string,
    ]),
  ).isRequired,
  applyScaleFix: PropTypes.bool.isRequired,
  globalScale: PropTypes.number.isRequired,
  windowHasFocus: PropTypes.bool.isRequired,
  groupAngle: PropTypes.number.isRequired,
  groupOpacity: PropTypes.number,
  groupScaleX: PropTypes.number.isRequired,
  groupScaleY: PropTypes.number.isRequired,
  transitionStatus: PropTypes.string.isRequired,
  matrixGroup: PropTypes.arrayOf(PropTypes.number),
};
Sketchfab.defaultProps = {
  hyperlink: null,
  matrixGroup: null,
  groupOpacity: 1,
};

export default Sketchfab;
